import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import { PersistGate } from 'redux-persist/integration/react';
import App from './App';
import { ConfigProvider } from './contexts/ConfigContext';
import './index.scss';
// import reportWebVitals from './reportWebVitals';
import { persister, store } from './store';

ReactDOM.render(
    <Provider store={store}>
        <ConfigProvider>
            <PersistGate loading={null} persistor={persister}>
                <App />
            </PersistGate>
        </ConfigProvider>
        <ToastContainer autoClose={3000} />
    </Provider>,
    document.getElementById('root')
);

// reportWebVitals();
